import { render } from "./PresupuestosPage.vue?vue&type=template&id=664e8b9e&scoped=true"
import script from "./PresupuestosPage.vue?vue&type=script&lang=js"
export * from "./PresupuestosPage.vue?vue&type=script&lang=js"

import "./PresupuestosPage.vue?vue&type=style&index=0&id=664e8b9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664e8b9e"]])

export default __exports__